import Cookie from "js-cookie";
export const COOKIE_CONSENT_KEY = "cookieconsent_status";
export const PERFORMANCE_COOKIE_KEY = "performance_cookie_consent";
export const FUNCTIONAL_COOKIE_KEY = "functional_cookie_consent";
export const ADVERTISING_COOKIE_KEY = "advertising_cookie_consent";
export const SESSION_ID_KEY = "SessionId";
// Interaction type constants for cookie consent tracking
export const INTERACTION_TYPE = {
    REJECT_ALL: 0,
    ACCEPT_ALL: 1,
    SAVE_SETTINGS: 3,
};
export function setCookie(name, value, expires, domain) {
    Cookie.set(name, value, { expires, domain });
}
export function getCookie(name) {
    return Cookie.get(name) || "";
}
export function deleteCookie(name, domain) {
    Cookie.remove(name, { path: "/", domain });
}
export function getStoredConsent() {
    // SSR guard - cookies not available during server-side rendering
    if (typeof window === "undefined") {
        return null;
    }
    try {
        const necessary = true;
        const performance = getCookie(PERFORMANCE_COOKIE_KEY) === "allow";
        const functional = getCookie(FUNCTIONAL_COOKIE_KEY) === "allow";
        const advertising = getCookie(ADVERTISING_COOKIE_KEY) === "allow";
        const consentStatus = getCookie(COOKIE_CONSENT_KEY);
        if (consentStatus) {
            return {
                necessary,
                performance,
                functional,
                advertising,
                timestamp: Date.now(),
                interactionType: INTERACTION_TYPE.SAVE_SETTINGS,
            };
        }
        return null;
    }
    catch {
        return null;
    }
}
export function storeConsent(consent) {
    const cookieExpiry = 100;
    setCookie(COOKIE_CONSENT_KEY, consent.necessary &&
        consent.performance &&
        consent.functional &&
        consent.advertising
        ? "allow"
        : !consent.performance && !consent.functional && !consent.advertising
            ? "deny"
            : "custom", cookieExpiry);
    setCookie(PERFORMANCE_COOKIE_KEY, consent.performance ? "allow" : "deny", cookieExpiry);
    setCookie(FUNCTIONAL_COOKIE_KEY, consent.functional ? "allow" : "deny", cookieExpiry);
    setCookie(ADVERTISING_COOKIE_KEY, consent.advertising ? "allow" : "deny", cookieExpiry);
}
export function getDefaultConsent() {
    return {
        necessary: true,
        performance: false,
        functional: false,
        advertising: false,
        // SSR guard - use 0 during SSR, actual time on client
        timestamp: typeof window !== "undefined" ? Date.now() : 0,
    };
}
export function getAllowedConsent() {
    return {
        necessary: true,
        performance: true,
        functional: true,
        advertising: true,
        // SSR guard - use 0 during SSR, actual time on client
        timestamp: Date.now(),
        interactionType: INTERACTION_TYPE.ACCEPT_ALL,
    };
}
export function getDeniedConsent() {
    return {
        necessary: true,
        performance: false,
        functional: false,
        advertising: false,
        timestamp: Date.now(),
        interactionType: INTERACTION_TYPE.REJECT_ALL,
    };
}
export function isConsentGiven() {
    return getCookie(COOKIE_CONSENT_KEY) !== "";
}
export function removeTrackingScripts() {
    // Remove Google Tag Manager
    const gtmScripts = document.querySelectorAll('script[data-identifier="google-tag-manager"]');
    gtmScripts.forEach((script) => script.remove());
    // Remove Google Analytics
    const gaScripts = document.querySelectorAll('script[data-identifier="google-analytics-india"]');
    gaScripts.forEach((script) => script.remove());
    // Remove Meta Pixel
    const pixelScripts = document.querySelectorAll('script[data-identifier="meta-pixel"]');
    pixelScripts.forEach((script) => script.remove());
    const pixelNoscripts = document.querySelectorAll('noscript[data-identifier="meta-pixel-noscript"]');
    pixelNoscripts.forEach((script) => script.remove());
    // Remove Hotjar
    const hotjarScripts = document.querySelectorAll('script[data-identifier="hotjar"]');
    hotjarScripts.forEach((script) => script.remove());
    // Remove GTM NoScript
    const gtmNoscripts = document.querySelectorAll('noscript[data-identifier="gtm-noscript"]');
    gtmNoscripts.forEach((script) => script.remove());
    // Remove anti-flicker snippets
    const flickerScripts = document.querySelectorAll('script[data-identifier="anti-flicker-snipper"]');
    flickerScripts.forEach((script) => script.remove());
}
export function getCookieDomain() {
    if (window.location.host.includes("localhost"))
        return undefined;
    return ".inito.com";
}
export async function updateSessionConsent(interactionType) {
    try {
        const sessionId = getCookie(SESSION_ID_KEY);
        if (!sessionId) {
            console.warn("No session ID found, skipping session update");
            return;
        }
        // Dynamically import EventManager to avoid circular dependency
        const { EventManager } = await import("../events/EventManager");
        // Create a minimal event data object (event name not needed for update)
        const eventManager = new EventManager({ name: "" });
        await eventManager.createOrUpdateSession("update", undefined, interactionType);
    }
    catch (error) {
        console.error("Error updating session consent:", error);
        // Don't throw - we don't want to block the user flow if the API fails
    }
}
